import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
import ProgressBar from "../progress-bar";
import StepInitial from "./StepInitial";
import StepAddToTeam from "./StepAddToTeam";
import { useMutation, useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
// import useAuthContext from "../../hooks/useAuthContext";
import { injectIntl } from "react-intl";
import Content from "../content";
import Button from "../button";
import Link from "../link";

const TEAMS_QUERY = gql`
  query AllTeams {
    allTeams {
      id
      name
    }
  }
`;

export const ADD_PLAYER = gql`
  mutation AddPlayer(
    $name: String!
    $surname: String!
    # $nickName: String!
    $number: Int
    $position: String!
    $dateOfBirth: String!
  ) {
    createPlayer(
      input: {
        name: $name
        surname: $surname
        # nickName: $nickName
        number: $number
        position: $position
        dateOfBirth: $dateOfBirth
      }
    ) {
      id
      name
      surname
      nickName
      number
      position
      dateOfBirth
    }
  }
`;

const StyledActionLink = styled(Link)(({ theme }: IStyledArguments) => {
  return {
    ...theme.typography.caption,
    color: theme.palette.secondary.dark,
    textDecoration: "none",
    textTransform: "uppercase",
  };
});

const ButtonRow = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

const MessageSpace = styled("div")(({ theme }: IStyledArguments) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
}));

const StyledPaper = styled(Paper)(({ theme }: IStyledArguments) => ({
  boxSizing: "border-box",
  padding: theme.spacing(4),
  marginBottom: theme.spacing(5),
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  maxWidth: 630,
  [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
    boxShadow: "none",
  },
}));

// interface IRegisterRequest {
//   code: string;
//   firstName: string;
//   lastName: string;
//   language: string;
//   password: string;
// }

// interface IPageRegisterProps {
//   onRegister: (arg0: IRegisterRequest) => null;
//   registrationCode: string;
//   intl: InjectedIntl;
// }

const PageNewPlayer = () => {
  const [userDetails, setUserDetails] = useState<any>();
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [teams, setTeams] = useState<any>(null);
  const { data: dataTeams } = useQuery(TEAMS_QUERY);
  const [addPlayer, { data, loading }] = useMutation(ADD_PLAYER);
  const handleAddPlayer = async (form: any) => {
    addPlayer({
      variables: {
        name: form.name,
        surname: form.surname,
        // nickName: form.nickname,
        number: Number(form.number),
        position: form.position,
        dateOfBirth: form.dateOfBirth,
      },
    });
  };

  useEffect(() => {
    if (loading) {
      return;
    }

    if (dataTeams) {
      setTeams(dataTeams.allTeams);
    }

    if (!data) {
      return;
    } else {
      console.log("data received....");
      console.log(data);
      setUserDetails(data.createPlayer);
      setCurrentStep(2);
    }
  }, [data, dataTeams]);

  if (loading) {
    // TODO: LOADING SPINNER
    return (
      <Content>
        <p>LOADING</p>
      </Content>
    );
  }

  // if (error) {
  //   return <Redirect to="/login" noThrow />;
  // }

  return (
    <Content>
      <Grid container spacing={0} justify="center" alignItems="center">
        <Grid item xs={12} md={6}>
          <StyledPaper>
            <ProgressBar steps={3} activeStep={currentStep} />
            {currentStep === 1 && (
              <StepInitial
                userDetails={userDetails}
                onGoNext={(values: any) => {
                  console.log(values);
                  handleAddPlayer(values);
                }}
              />
            )}
            {currentStep === 2 && (
              <StepAddToTeam
                userDetails={userDetails}
                teams={teams}
                onGoNext={() => {
                  setCurrentStep(3);
                }}
              />
            )}
            {currentStep === 3 && (
              <Content>
                <svg
                  height="80px"
                  viewBox="-80 0 496 496"
                  width="80px"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <linearGradient
                    id="a"
                    gradientUnits="userSpaceOnUse"
                    x1="168"
                    x2="168"
                    y1="496"
                    y2="0"
                  >
                    <stop offset="0" stop-color="#FF5722" />
                    <stop offset="1" stop-color="#0bb1d3" />
                  </linearGradient>
                  <path
                    d="m282.550781 323.601562-66.550781-17.746093v-6.847657c17.65625-10.246093 31.777344-25.910156 40-44.761718v1.753906c22.054688 0 40-17.945312 40-40v-88c0-70.574219-57.425781-128-128-128s-128 57.425781-128 128v88c0 22.054688 17.945312 40 40 40v-1.742188c8.222656 18.847657 22.34375 34.511719 40 44.757813v6.847656l-66.550781 17.746094c-31.472657 8.390625-53.449219 37-53.449219 69.558594v102.832031h336v-102.832031c0-32.558594-21.976562-61.167969-53.449219-69.566407zm-21.574219-84.136718c1.902344-7.519532 3.023438-15.359375 3.023438-23.464844v-22.527344c9.289062 3.3125 16 12.113282 16 22.527344 0 11.527344-8.167969 21.167969-19.023438 23.464844zm-92.976562-223.464844c61.761719 0 112 50.238281 112 112v56.207031c-4.671875-3.535156-10.054688-6.183593-16-7.390625v-40.816406h-8c-17.535156 0-34.28125-8.375-44.808594-22.398438l-11.191406-14.9375-6.398438 8.527344c-13.53125 18.039063-35.066406 28.808594-57.601562 28.808594h-64v40.808594c-5.945312 1.214844-11.328125 3.855468-16 7.390625v-56.199219c0-61.761719 50.238281-112 112-112zm-112 200c0-10.414062 6.710938-19.214844 16-22.527344v22.527344c0 8.105469 1.121094 15.945312 3.023438 23.464844-10.855469-2.296875-19.023438-11.9375-19.023438-23.464844zm32 0v-64h48c24.039062 0 47.144531-10.015625 63.617188-27.214844 11.910156 14.984375 29.480468 24.621094 48.382812 26.765625v64.449219c0 44.113281-35.886719 80-80 80s-80-35.886719-80-80zm80 96c11.230469 0 21.976562-2.039062 32-5.601562v5.601562c0 17.648438-14.351562 32-32 32s-32-14.351562-32-32v-5.601562c10.023438 3.5625 20.769531 5.601562 32 5.601562zm-110.433594 27.054688 63.523438-16.933594c4.664062 21.613281 23.910156 37.878906 46.910156 37.878906s42.246094-16.265625 46.902344-37.878906l63.523437 16.933594c3.148438.839843 6.167969 1.960937 9.054688 3.296874l-16.703125 25.054688c-9.664063 14.488281-14.777344 31.378906-14.777344 48.808594v40.105468l-204.566406-115.0625c2.015625-.800781 4.007812-1.632812 6.132812-2.203124zm22.433594 82.617187 103.6875 58.328125h-103.6875zm-2.128906-19.542969c-3.007813-13.695312-9.191406-26.609375-18.253906-37.503906l-.65625-.792969 197.039062 110.839844v5.328125h-39.695312zm-46.863282-46.824218 16.304688 19.558593c10.765625 12.929688 16.6875 29.296875 16.6875 46.097657v11.039062h-48v-38.832031c0-14.441407 5.6875-27.761719 15.007812-37.863281zm-15.007812 92.695312h48v32h-48zm256 32v-32h48v32zm48-48h-48v-15.785156c0-14.261719 4.175781-28.078125 12.097656-39.933594l16.742188-25.113281c11.824218 10.390625 19.160156 25.503906 19.160156 42zm-152-152c-26.472656 0-48-21.527344-48-48h16c0 17.648438 14.351562 32 32 32s32-14.351562 32-32h16c0 26.472656-21.527344 48-48 48zm-48-96c-4.414062 0-8-3.585938-8-8s3.585938-8 8-8 8 3.585938 8 8-3.585938 8-8 8zm88-8c0-4.414062 3.585938-8 8-8s8 3.585938 8 8-3.585938 8-8 8-8-3.585938-8-8zm32 216h-32v-16h32zm0 0"
                    fill="url(#a)"
                  />
                </svg>
                <MessageSpace>
                  Player {userDetails && userDetails.name} created
                </MessageSpace>
                <ButtonRow>
                  <StyledActionLink to="/people/players">
                    <Button>Ok</Button>
                  </StyledActionLink>
                </ButtonRow>
              </Content>
            )}
          </StyledPaper>
        </Grid>
      </Grid>
    </Content>
  );
};

export default injectIntl(PageNewPlayer);
